import './NotFound.css';
import { NavLink } from 'react-router-dom';
import RocketPath from '/src/assets/img/svg/rocket.svg';
import MoonPath from '/src/assets/img/svg/moon.svg';
import AstronautPath from '/src/assets/img/svg/astronaut.svg';
import { env } from '../../var/env';
import storage from '/src/utils/storage';
function NotFound() {
    
    return (
        <div className="bg-container">
            <div className="stars">
                <div className="custom-navbar">
                    <div className="brand-logo"></div>
                </div>
                <div className="central-body">
                    <div className='title'>404</div>
                    <div>The page that you are looking for doesn't exist</div>      
                    <NavLink to={"/login"} className="btn-go-home">GO BACK HOME</NavLink>
                </div>
                <div className="objects">
                    <img className="object_rocket" src={RocketPath} width="60px"/>
                    <div className="earth-moon">
                        <img className="object_moon" src={MoonPath} width="200px"/>
                    </div>
                <div className="box_astronaut">
                    <img className="object_astronaut" src={AstronautPath} width="140px"/>
                </div>
            </div>
            <div className="glowing_stars">
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
            </div>

            </div>
        </div>
    )
}

export default NotFound;